export default __webpack_public_path__ + "static/media/myself.0b64ebc0.jpg";